import { SummaryLayoutItem } from "@/Patient/Models/SummaryLayoutItem";

class SummaryConfigurationSettings {
    public ShowProblemsDescription: { [key: string]: boolean };
    public SummaryLayouts: { [key: string]: SummaryLayoutItem[] };

    constructor(showProblemsDescription: { [key: string]: boolean }, summaryLayouts: { [key: string]: SummaryLayoutItem[] }) {
        this.ShowProblemsDescription = showProblemsDescription;
        this.SummaryLayouts = summaryLayouts;
    }
}

export { SummaryConfigurationSettings };
